// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-790afad9] {\n  width: 100%;\n  min-height: 500px;\n  background-color: #fff;\n}\n.responsive-iframe[data-v-790afad9] {\n  padding: 0px;\n  margin: 0px;\n  border: 0;\n  max-width: 100%;\n  min-width: 100%;\n}", ""]);
// Exports
module.exports = exports;
